<template>
  <section class="topUp small-form">
    <h1>Top up your sim</h1>
    <h2>Select option</h2>
    <form role="form">
      <div v-if="!isLoggedIn">
        <p>
          Do you have an account?
          <router-link to="/secure">Login here</router-link>
        </p>
      </div>

      <h3>Enter your 19 digit Sim IDs</h3>
      <p>You can insert a comma or whitespace separated list.</p>
      <textarea v-model="rawSimIds" class="w-100 mb-1" rows="10"></textarea>

      <div v-if="invalidIDs.length" class="alert alert-danger text-left mb-1">
        Invalid IDs:
        <ul class="list-unstyled">
          <li v-for="invalidID in invalidIDs" :key="invalidID">
            {{ invalidID }}
          </li>
        </ul>
      </div>
      <div
        v-if="invalidFormatIDs.length"
        class="alert alert-danger text-left mb-1"
      >
        Invalid format for IDs:
        <ul class="list-unstyled">
          <li
            v-for="invalidFormatID in invalidFormatIDs"
            :key="invalidFormatID"
          >
            {{ invalidFormatID }}
          </li>
        </ul>
      </div>

      <select class="custom-select mb-2" v-model="rateplan">
        <option value="" selected disabled>Select a bundle</option>
        <option
          v-for="rateplan in rateplans"
          :key="rateplan.id"
          :value="rateplan.id"
        >
          {{ rateplan.displayName }}
        </option>
      </select>

      <button
        type="button"
        @click="topUp()"
        class="btn btn-primary"
        :disabled="rateplan === '' || isLoading"
      >
        <span v-if="!isLoading">Top up</span>
        <span v-if="isLoading">Loading</span>
      </button>
      <ul class="list-unstyled text-left mt-2">
        <li v-for="result in topUpResult" :key="result.iccid">
          {{ result.iccid }}:
          <span v-if="result.success">OK</span>
          <strong v-if="!result.success">Failed</strong>
        </li>
      </ul>
    </form>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import loading from '../mixins/loading'

export default {
  name: 'Topup',
  components: {},
  mixins: [loading],
  data() {
    return {
      loading: {
        topUp: false,
      },
      rawSimIds: '',
      rateplan: '',
      invalidIDs: [],
      invalidFormatIDs: [],
      rateplans: [],
      topUpResult: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'username']),
  },
  methods: {
    ...mapActions('toast', ['addToast']),
    topUp() {
      this.invalidFormatIDs = []
      this.invalidIDs = []
      this.topUpResult = []
      const simIDs = [
        ...new Set(this.rawSimIds.split(/[\s,]+/g)), // dedupe
      ].filter(id => id)
      const validSimID = /^\d{19}$/
      this.invalidFormatIDs = simIDs.filter(id => !validSimID.test(id))

      if (this.invalidFormatIDs.length === 0) {
        this.loading.topUp = true
        axios
          .post('/rest/iccid', simIDs)
          .then(result => {
            this.invalidIDs = result.data
              .filter(validation => !validation.valid)
              .map(validation => validation.iccid)

            if (this.invalidIDs.length === 0) {
              // POST the data
              return axios
                .post(
                  '/rest/iccid/topup',
                  simIDs.map(iccid => ({
                    iccid,
                    rateplanId: this.rateplan,
                  }))
                )
                .catch(e => e)
                .then(result => {
                  this.topUpResult = result.data
                })
                .catch(() => {
                  this.$store.dispatch(
                    'toast/addToast',
                    {
                      message: 'Error communicating with server',
                      type: 'danger',
                    },
                    { root: true }
                  )
                })
            }
          })
          .finally(() => (this.loading.topUp = false))
      }
    },
  },
  created() {
    axios
      .get('/rest/rateplan')
      .then(result => {
        if (result.status >= 400) {
          throw new Error(
            `Received status [${result.status}] on rateplans call`
          )
        }
        this.rateplans = result.data
      })
      .catch(() => {
        this.$store.dispatch(
          'toast/addToast',
          {
            message: 'Error communicating with server',
            type: 'danger',
          },
          { root: true }
        )
      })
  },
}
</script>

<style lang="scss">
.small-form {
  text-align: center;

  form {
    width: 268px;
    margin: 0 auto;
  }

  .form-header {
    text-align: left;
  }
}
</style>
